import "@arco-design/web-react/es/Dropdown/style";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import _IconDown from "@arco-design/web-react/icon/react-icon/IconDown";
import "@arco-design/web-react/es/Typography/style";
import _Typography from "@arco-design/web-react/es/Typography";
import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import _IconPlus from "@arco-design/web-react/icon/react-icon/IconPlus";
import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import _IconCheck from "@arco-design/web-react/icon/react-icon/IconCheck";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import _IconApps from "@arco-design/web-react/icon/react-icon/IconApps";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import IconGlobal from '@/assets/icons/earth.svg';
import { useSelector, useDispatch } from 'react-redux';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import Logo from '@/assets/logo.svg';
import LogoDark from '@/assets/logo-dark.svg';
import { brandingLogo, useBranding } from '@/utils/branding';
import IconButton from './IconButton';
import ScopeSwitcher from './ScopeSwitcher';
import Settings from '../Settings';
import styles from './style/index.module.less';
import defaultLocale from '@/locale';
import useStorage from '@/utils/useStorage';
import { generatePermission, useRouteUrl } from '@/routes';
import { removeToken } from '@/utils/storage';
import { ApiSwitchTeam } from '@/api';
import rootReducer from '@/store';
import { createStore } from 'redux';
const SubMenu = _Menu.SubMenu;
const store = createStore(rootReducer);

function Navbar({
  show
}) {
  const history = useHistory();
  const t = useLocale();
  const userInfo = useSelector(state => state.userInfo);
  const dispatch = useDispatch();
  const [_, setUserStatus] = useStorage('userStatus');
  const [role, setRole] = useStorage('userRole', 'admin');
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext); // 白标: 访问的域名配置了品牌时用它替换默认 Logo(深色模式优先 logo_dark)

  const branding = useBranding();
  const brandingLogoUrl = brandingLogo(branding, theme); // 团队管理入口: 只有 admin (members.role) 可见, 与 routes/config.tsx 的 roles 门禁一致

  const isAdmin = userInfo?.role === 'admin';
  const teamUrl = useRouteUrl('team'); // 账号设置入口: 所有登录用户可见, 直达叶子页避免多一次 redirect

  const accountUrl = useRouteUrl('account/profile');

  function logout() {
    setUserStatus('logout');
    removeToken();
    history.push('/login');
  }

  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout();
    } else if (key === 'team') {
      // 进入 /team 作用域 (侧边栏随之切换为团队菜单)
      if (teamUrl && teamUrl !== '#') {
        history.push(teamUrl);
      }
    } else if (key === 'setting') {
      // 进入 /account 作用域 (侧边栏随之切换为账号菜单)
      if (accountUrl && accountUrl !== '#') {
        history.push(accountUrl);
      }
    } else if (key === 'create') {
      console.log(key);
    } else {
      const params = {
        team: key
      };
      ApiSwitchTeam(params).then(res => {
        dispatch({
          type: 'update-userInfo',
          payload: {
            userInfo: { ...userInfo,
              team: params.team
            }
          }
        });
      });
      window.location.reload();

      _Message.info(`You clicked ${key}`);
    }
  }

  useEffect(() => {
    dispatch({
      type: 'update-userInfo',
      payload: {
        userInfo: { ...userInfo,
          permissions: generatePermission(role)
        }
      }
    });
  }, [role]);

  if (!show) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['fixed-settings']
    }, /*#__PURE__*/React.createElement(Settings, {
      trigger: /*#__PURE__*/React.createElement(_Button, {
        icon: /*#__PURE__*/React.createElement(_IconSettings, null),
        type: "primary",
        size: "large"
      })
    }));
  }

  const handleChangeRole = () => {
    const newRole = role === 'admin' ? 'user' : 'admin';
    setRole(newRole);
  };

  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    onClickMenuItem: onMenuItemClick,
    style: {
      width: 200
    }
  }, userInfo.teams &&
  /*#__PURE__*/
  // 标题必须包成一个节点: header 是 flex + space-between, 图标与文字若各是一个 flex item
  // 会被 space-between 摊开 (文字被挤到中间), 与下面的 Menu.Item 不对齐。
  React.createElement(SubMenu, {
    key: "teams",
    title: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_IconApps, {
      className: styles['dropdown-icon']
    }), t['nav.team.title'])
  }, userInfo.teams.map((team, index) => {
    return /*#__PURE__*/React.createElement(_Menu.Item, {
      key: `${team.id}`
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/React.createElement(_Space, null, /*#__PURE__*/React.createElement(_Avatar, {
      size: 24,
      shape: "square"
    }, /*#__PURE__*/React.createElement("img", {
      src: team.avatar
    })), team.name), /*#__PURE__*/React.createElement("div", null, team.id == userInfo.team_id && /*#__PURE__*/React.createElement(_IconCheck, {
      style: {
        color: 'green'
      }
    }))));
  }), /*#__PURE__*/React.createElement(_Divider, {
    style: {
      margin: '4px 0'
    }
  }), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "create"
  }, /*#__PURE__*/React.createElement(_IconPlus, null), " ", t['nav.team.add'])), isAdmin && /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "team"
  }, /*#__PURE__*/React.createElement(_IconSettings, {
    className: styles['dropdown-icon']
  }), t['nav.team.manage']), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "setting"
  }, /*#__PURE__*/React.createElement(_IconUser, {
    className: styles['dropdown-icon']
  }), t['nav.account.manage']), /*#__PURE__*/React.createElement(_Divider, {
    style: {
      margin: '4px 0'
    }
  }), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout"
  }, /*#__PURE__*/React.createElement(_IconPoweroff, {
    className: styles['dropdown-icon']
  }), t['navbar.logout']));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, brandingLogoUrl ? /*#__PURE__*/React.createElement("img", {
    src: brandingLogoUrl,
    alt: branding?.brand_name,
    style: {
      height: 24
    }
  }) : theme !== 'dark' ? /*#__PURE__*/React.createElement(Logo, null) : /*#__PURE__*/React.createElement(LogoDark, null)), /*#__PURE__*/React.createElement(ScopeSwitcher, null)), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Select, {
    triggerElement: /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(IconGlobal, {
        className: "arco-icon"
      })
    }),
    options: [{
      label: 'English',
      value: 'en-US'
    }, {
      label: 'Español',
      value: 'es-ES'
    }, {
      label: 'Français',
      value: 'fr-FR'
    }, {
      label: 'Deutsch',
      value: 'de-DE'
    }, {
      label: '日本語',
      value: 'ja-JP'
    }, {
      label: '简体中文',
      value: 'zh-CN'
    }],
    value: lang,
    triggerProps: {
      autoAlignPopupWidth: false,
      autoAlignPopupMinWidth: true,
      position: 'br'
    },
    trigger: "hover",
    onChange: value => {
      setLang(value);
      const nextLang = defaultLocale[value]; // Message.info(`${nextLang['message.lang.tips']}${value}`);
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Tooltip, {
    content: theme === 'light' ? t['settings.navbar.theme.toDark'] : t['settings.navbar.theme.toLight']
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: theme !== 'dark' ? /*#__PURE__*/React.createElement(_IconMoonFill, null) : /*#__PURE__*/React.createElement(_IconSunFill, null),
    onClick: () => setTheme(theme === 'light' ? 'dark' : 'light')
  }))), userInfo && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Dropdown, {
    droplist: droplist,
    position: "br"
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    style: {
      padding: 2
    }
  }, /*#__PURE__*/React.createElement(_Avatar, {
    size: 24
  }, userInfo.avatar ? /*#__PURE__*/React.createElement("img", {
    src: userInfo.avatar,
    alt: userInfo.email
  }) : (userInfo.email || '?').slice(0, 1).toUpperCase()), /*#__PURE__*/React.createElement(_Typography.Text, null, " ", userInfo.email), /*#__PURE__*/React.createElement(_IconDown, null))))));
}

export default Navbar;